<template>
  <div class="cs-simple-table-operations">
    <el-button
      type="text"
      v-for="(item, index) in operationsList"
      :key="index"
      @click="clickAction(item.action)"
      :disabled="item.disabled"
      >{{ item.label }}</el-button
    >
    <el-dropdown v-if="dropdownVisible">
      <span class="el-dropdown-link">
        <el-button type="text">更多</el-button>
        <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-for="(item, index) in operations.slice(3)"
          :key="index"
          @click.native="clickAction(item.action)"
          :disabled="item.disabled"
          >{{ item.label }}</el-dropdown-item
        >
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
export default {
  name: "ColumnOperations",
  props: {
    row: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
    $index: {
      type: Number,
      required: true,
    },
    operations: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
  },
  computed: {
    dropdownVisible() {
      return this.operations.length > 4;
    },
    operationsList() {
      if (this.dropdownVisible) {
        return this.operations.slice(0, 3);
      } else {
        return this.operations;
      }
    },
  },
  mounted() {
    const intersectionObserver = new IntersectionObserver(
      (entries) => {
        const observer = entries[0];
        // 当组件显示后,再进行宽度计算
        if (observer.intersectionRatio > 0) {
          const width = observer.target.offsetWidth + 36;
          this.$emit("setWidth", width > 56 ? width : 56);
        }
      },
      {
        threshold: [0],
      }
    );
    intersectionObserver.observe(this.$el);
  },
  methods: {
    clickAction(action) {
      if (typeof action === "function") {
        action(this.row, this.column, this.index);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.cs-simple-table-operations {
  white-space: nowrap;
  display: inline-flex;
  ::v-deep {
    .el-button--small {
      font-size: 12px;
      padding-top: 0;
      padding-bottom: 0;
    }
  }
  .el-dropdown {
    font-size: inherit;
    ::v-deep {
      .el-dropdown-link {
        padding: 2px 0 2px 5px;
        margin: 0 0 0 5px;
      }
    }
  }
}
</style>
